import { render, staticRenderFns } from "./ExamesEntrada-comp.vue?vue&type=template&id=7897f24c&scoped=true&"
import script from "./ExamesEntrada-comp.vue?vue&type=script&lang=js&"
export * from "./ExamesEntrada-comp.vue?vue&type=script&lang=js&"
import style0 from "./ExamesEntrada-comp.vue?vue&type=style&index=0&id=7897f24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897f24c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VForm,VSnackbar,VTab,VTabItem,VTabs,VTabsSlider})
